// Last line of defence: an error while rendering shows a Slovenian fallback page instead of a blank
// screen. Unsent changes and recordings stay in the browser storage, so reloading loses nothing.
import { Component, type ErrorInfo, type MouseEvent, type ReactNode } from 'react';
import { Icon } from './Icon';

interface ErrorBoundaryState {
  failed: boolean;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { failed: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { failed: true };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo): void {
    console.error('[app] unexpected error', error, info.componentStack);
  }

  /** The hash first: the app, mounted again, reads its route from it. */
  private goHome = (event: MouseEvent<HTMLAnchorElement>): void => {
    event.preventDefault();
    window.location.hash = '#/';
    this.setState({ failed: false });
  };

  override render(): ReactNode {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="app">
        <main className="main">
          <div className="page page--center error-page">
            <div className="notice notice--error" role="alert">
              <Icon name="alert" size={20} className="notice__icon" />
              <div className="notice__content">
                <p className="notice__title">Prišlo je do nepričakovane napake.</p>
                <p>Posnetki in spremembe, shranjeni v tej napravi, se ob osvežitvi ne izgubijo.</p>
                <div className="error-page__actions">
                  <button type="button" className="btn btn--primary" onClick={() => window.location.reload()}>
                    <Icon name="refresh" size={20} /> Osveži stran
                  </button>
                  <a href="#/" className="btn btn--secondary" onClick={this.goHome}>
                    Na začetek
                  </a>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}
